@if (text) {
  <span
    [matTooltip]="disabled && tooltip ? (getTooltip() | transloco) : ''"
    [matTooltipDisabled]="!disabled || !tooltip"
  >
    <button
      *appPermission="permission"
      type="button"
      class="a-tcmrActionButton__button py-2 px-6 rounded disabled:opacity-50"
      [ngClass]="getClass()"
      [disabled]="disabled"
      (click)="onClick()"
    >
      {{ getText() | transloco }}
    </button>
  </span>
} @else {
  @if (this.plain) {
    <button
      *appPermission="permission"
      type="button"
      class="disabled:opacity-50"
      [disabled]="disabled"
      [ngClass]="getClass()"
      (click)="onClick()"
    >
      <mat-icon [matTooltip]="getTooltip()">{{ icon }}</mat-icon>
    </button>
  } @else {
    <button
      *appPermission="permission"
      type="button"
      class="a-tcmrActionButton__button pt-2 pb-px px-6 rounded disabled:opacity-50"
      [ngClass]="getClass()"
      [disabled]="disabled"
      (click)="onClick()"
    >
      <mat-icon>{{ icon }}</mat-icon>
    </button>
  }
}
